import IndicesRevisionGenerationFormController from './indices.revision.generation.controller';

export default {
    template: require('./indices.revision.generation.html'),
    controller: IndicesRevisionGenerationFormController
};
